import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import Drawer from 'components/Drawer'
import DrawerView from 'components/DrawerStudentView'

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    &::-webkit-scrollbar {
      display: none;
    }
  }
`
export const StyledDrawerView = styled(DrawerView)``
export const DrawerHeader = styled(Flex)`
  width: 98%;
  flex-wrap: ${props => (props.flexWrap ? props.flexWrap : '')};
  gap: ${props => (props.gap ? props.gap : '')};
  background-color: white;
  width: 100%;
  flex-wrap: wrap;
  gap: 10px;
  position: sticky;
  top: 0;
  z-index: 1000;
`
export const HeaderFlexOne = styled(Flex)`
  gap: 10px;
  width: 'max-content';
`
export const InfoSection = styled(Flex)`
  gap: 5px;
  margin-left: 10px;
`
export const StudentName = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: 700;
  font-size: 1.125em;
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
  @media (max-width: 768px) {
    font-size: 1em;
  }

  @media (max-width: 480px) {
    font-size: 0.875em;
  }
`
export const CollegeName = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: 600;
  font-size: 0.975em;
  line-height: 18px;
  letter-spacing: 0.1em;
  color: ${COLORS.GREY_T_50};
  display: flex;
  gap: 10px;
  align-items: center;
  word-wrap: break-word;
  @media (max-width: 768px) {
    font-size: 0.576em;
    gap: 5px;
  }

  @media (max-width: 480px) {
    font-size: 0.875em;
    gap: 3px;
  }
`
export const NavHeading = styled.h2`
  margin-bottom: 18px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: inherit;
  margin-bottom: 0;
`
export const StudentInfoFlex = styled(Flex)``
